import type { ReactNode } from "react";
import { InfoIcon } from "./InfoIcon";
import { Text } from "./Text";
import { type Align, Tooltip } from "./Tooltip";

export function HelpTooltip({
  content,
  align,
}: {
  content: ReactNode;
  align?: Align;
}) {
  return (
    <Tooltip
      align={align}
      content={
        <div style={{ width: 200, textWrap: "pretty" }}>
          <Text variant="text-small-md">{content}</Text>
        </div>
      }
    >
      <InfoIcon />
    </Tooltip>
  );
}
